import { render } from "./my-payslips.vue?vue&type=template&id=00ebeb48&scoped=true"
import script from "./my-payslips.vue?vue&type=script&lang=js"
export * from "./my-payslips.vue?vue&type=script&lang=js"

import "./my-payslips.vue?vue&type=style&index=0&id=00ebeb48&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ebeb48"]])

export default __exports__